import NavBarLogo from "@components/common/NavBar/NavBarLogo";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import clsx from "clsx";
import { FC, memo } from "react";
import BenefitsBar from "@components/common/BenefitsBar";
import { ComponentBlocksBenefitsBar } from "@lib/generated/graphql";
import ApplicationHeaderNav from "@modules/application/components/SplitLayout/ApplicationHeaderNav";

interface ApplicationHeaderProps {
  border?: boolean;
  onContactClick?: VoidFunction;
}

const ApplicationHeader: FC<ApplicationHeaderProps> = memo(
  function ApplicationHeader({ border, onContactClick }) {
    const { partner } = usePartnerContext();
    const benefitsBarData = {
      id: "1",
      items: [
        {
          id: "1",
          label: "Deutschlandweit verfügbar",
          mobileLabel: "Deutschlandweit",
          icon: {
            id: "1",
            type: "LocalTwo",
          },
        },
        {
          id: "2",
          label: "Kostenlos für Käufer",
          icon: {
            id: "2",
            type: "Like",
          },
        },
        {
          id: "3",
          label: "030 9173 9560",
          mobileLabel: "030 9173 9560",
          href: "tel:03091739560",
          icon: {
            id: "3",
            type: "PhoneTelephone",
          },
        },
      ],
    } as ComponentBlocksBenefitsBar;

    return (
      <header
        className={clsx("flex flex-col gap-3xs", {
          "border-b border-b-neutral-25": border,
        })}
      >
        <BenefitsBar data={benefitsBarData} />
        <div className="flex px-s items-center">
          <NavBarLogo
            className="mx-s mb-3xs justify-center m:justify-start"
            href={partner?.returnUrl || "/"}
            partner={partner}
          />
          <ApplicationHeaderNav onContactClick={onContactClick} />
        </div>
      </header>
    );
  },
);

export default ApplicationHeader;
